export default __webpack_public_path__ + "static/media/Monzo_Bank.d67d14a8.svg";